/* src/app/builder-screen-beta/inspector/inspector.component.scss */
.inspector-container {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #fafafa;
  overflow: hidden;
}
.inspector-search {
  position: sticky;
  top: 0;
  z-index: 11;
  padding: 6px 10px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}
.inspector-search ::ng-deep .ant-input {
  font-size: 12px;
}
.component-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: white;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 0;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 10;
}
.component-header .component-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.component-header .component-info nz-tag {
  margin: 0;
}
.component-header .preset-actions button {
  display: flex;
  align-items: center;
  gap: 4px;
}
.preset-selector {
  margin: 0 10px 6px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  flex-shrink: 0;
  position: sticky;
  top: 48px;
  z-index: 9;
  background: white;
}
.preset-selector .preset-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
  margin-bottom: 8px;
}
.preset-selector .preset-item {
  padding: 8px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.preset-selector .preset-item:hover {
  border-color: #1890ff;
  background-color: #f6ffed;
}
.preset-selector .preset-item .preset-name {
  font-weight: 500;
  color: #262626;
  margin-bottom: 4px;
}
.preset-selector .preset-item .preset-description {
  font-size: 12px;
  color: #8c8c8c;
}
.preset-selector .preset-actions {
  text-align: right;
  border-top: 1px solid #f0f0f0;
  padding-top: 8px;
  margin-top: 8px;
}
form {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 6px 10px 10px;
  min-height: 0;
  max-height: 100%;
  scroll-behavior: smooth;
}
form::-webkit-scrollbar {
  width: 8px;
}
form::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 5px;
  margin: 2px 0;
}
form::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 5px;
  border: 1px solid #f5f5f5;
}
form::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}
form::-webkit-scrollbar-thumb:active {
  background: #999999;
}
form ::ng-deep .ant-collapse {
  background: transparent;
  border: none;
}
form ::ng-deep .ant-collapse .ant-collapse-item {
  margin-bottom: 6px;
  background: white;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
}
form ::ng-deep .ant-collapse .ant-collapse-item:last-child {
  margin-bottom: 12px;
}
form ::ng-deep .ant-collapse .ant-collapse-item .ant-collapse-header {
  padding: 10px 12px;
  font-weight: 500;
  font-size: 13px;
  color: #262626;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 6px 6px 0 0;
  transition: background-color 0.2s ease;
}
form ::ng-deep .ant-collapse .ant-collapse-item .ant-collapse-header:hover {
  background-color: #f8f9fa;
}
form ::ng-deep .ant-collapse .ant-collapse-item .ant-collapse-header[aria-expanded=true] {
  background-color: #f0f7ff;
  border-bottom-color: #e6f7ff;
}
form ::ng-deep .ant-collapse .ant-collapse-item .ant-collapse-content {
  border: none;
  background: white;
}
form ::ng-deep .ant-collapse .ant-collapse-item .ant-collapse-content .ant-collapse-content-box {
  padding: 10px 12px;
}
form ::ng-deep .ant-collapse .ant-collapse-item.ant-collapse-item-active .ant-collapse-header {
  background-color: #f6ffed;
  border-bottom-color: #d9f7be;
}
.properties-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}
.properties-grid .property-item .ant-form-item {
  margin-bottom: 0;
}
.properties-grid .property-item .property-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
}
.properties-grid .property-item .property-label .help-icon {
  color: #1890ff;
  cursor: help;
  font-size: 13px;
}
.properties-grid .property-item .property-label .help-icon:hover {
  color: #40a9ff;
}
.property-group .group-description {
  font-size: 11px;
  color: #8c8c8c;
  margin-bottom: 10px;
  padding: 6px 10px;
  background: #f9f9f9;
  border-radius: 4px;
}
.nested-collapse ::ng-deep .ant-collapse-item {
  margin-bottom: 4px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
}
.nested-collapse ::ng-deep .ant-collapse-item .ant-collapse-header {
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 400;
}
.nested-collapse ::ng-deep .ant-collapse-item .ant-collapse-content-box {
  padding: 12px;
}
.grid-position-controls .grid-position-info {
  margin-bottom: 10px;
  text-align: center;
}
.grid-position-controls .grid-span-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}
.grid-position-controls .grid-span-controls nz-input-number {
  flex: 1;
}
.grid-position-controls .grid-span-controls button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}
.column-config-row {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
}
.column-config-row input {
  min-width: 0;
}
.column-config-row nz-select {
  flex-shrink: 0;
}
.column-config-row label {
  flex-shrink: 0;
  margin: 0;
}
.column-config-row button {
  flex-shrink: 0;
}
.property-preview .preview-label {
  font-weight: 500;
  margin-bottom: 8px;
  color: #262626;
  font-size: 12px;
}
.property-preview .preview-container {
  padding: 10px;
  background: #f9f9f9;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  min-height: 60px;
}
.property-preview .preview-container .preview-component .ant-form-item {
  margin-bottom: 0;
}
.property-preview .preview-container .preview-component input,
.property-preview .preview-container .preview-component textarea,
.property-preview .preview-container .preview-component nz-input-number,
.property-preview .preview-container .preview-component nz-select,
.property-preview .preview-container .preview-component nz-date-picker,
.property-preview .preview-container .preview-component nz-switch {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}
.no-selection {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
}
.no-selection ::ng-deep .ant-empty .ant-empty-description {
  color: #8c8c8c;
}
::ng-deep .ant-form-item-has-error .ant-input,
::ng-deep .ant-form-item-has-error .ant-input-number,
::ng-deep .ant-form-item-has-error .ant-select-selector,
::ng-deep .ant-form-item-has-error .ant-picker {
  border-color: #ff4d4f;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
}
::ng-deep .ant-form-item-has-warning .ant-input,
::ng-deep .ant-form-item-has-warning .ant-input-number,
::ng-deep .ant-form-item-has-warning .ant-select-selector,
::ng-deep .ant-form-item-has-warning .ant-picker {
  border-color: #faad14;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
}
@media (max-width: 768px) {
  .component-header {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .component-header .preset-actions {
    align-self: flex-end;
  }
  .preset-grid {
    grid-template-columns: 1fr;
  }
  .column-config-row {
    flex-direction: column;
    align-items: stretch;
  }
  .column-config-row input,
  .column-config-row nz-select {
    width: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .preset-item,
  .ant-collapse-header {
    transition: none;
  }
}
@media (prefers-color-scheme: dark) {
  .inspector-container {
    background: #141414;
  }
  .component-header {
    background: #1f1f1f;
    border-bottom-color: #303030;
  }
  .preset-item {
    background: #1f1f1f;
    border-color: #303030;
  }
  .preset-item:hover {
    background-color: #262626;
    border-color: #1890ff;
  }
  .preset-item .preset-name {
    color: #ffffff;
  }
  .preset-item .preset-description {
    color: #bfbfbf;
  }
  .property-group .group-description {
    background: #262626;
    color: #bfbfbf;
  }
  .preview-container {
    background: #262626;
    border-color: #303030;
  }
}
.color-sections {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.color-section {
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 8px 10px;
}
.color-section .section-header {
  margin-bottom: 8px;
}
.color-section .section-header .section-title {
  font-size: 12px;
  font-weight: 600;
  color: #262626;
  display: flex;
  align-items: center;
  gap: 4px;
}
.color-section .color-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 8px;
}
.color-section .color-grid .color-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.color-section .color-grid .color-item .color-label {
  font-size: 11px;
  font-weight: 500;
  color: #595959;
  margin: 0;
  line-height: 1.2;
}
.color-section .color-grid .color-item nz-color-picker {
  width: 100%;
}
.dark-theme .color-section {
  background: #262626;
  border-color: #434343;
}
.dark-theme .color-section .section-header .section-title {
  color: #f0f0f0;
}
.dark-theme .color-section .color-grid .color-item .color-label {
  color: #bfbfbf;
}
.datagrid-tabs ::ng-deep .ant-tabs-nav {
  margin-bottom: 8px !important;
}
.datagrid-tabs ::ng-deep .ant-tabs-tab {
  padding: 4px 10px !important;
  font-size: 12px !important;
}
.datagrid-tabs ::ng-deep .ant-tabs-content {
  padding: 0 !important;
}
@media (max-width: 768px) {
  .color-grid {
    grid-template-columns: 1fr !important;
  }
  .inspector-container .component-header {
    padding: 10px 12px;
  }
  .inspector-container .component-header .component-info nz-tag {
    font-size: 11px;
  }
  .inspector-container form {
    padding: 6px 12px 12px;
  }
  .inspector-container form::-webkit-scrollbar {
    width: 6px;
  }
  .inspector-container ::ng-deep .ant-collapse-item {
    margin-bottom: 8px;
  }
  .inspector-container ::ng-deep .ant-collapse-item .ant-collapse-header {
    padding: 10px 12px;
    font-size: 13px;
  }
  .inspector-container ::ng-deep .ant-collapse-item .ant-collapse-content-box {
    padding: 12px;
  }
}
.tab-icon-section .icon-option {
  display: flex;
  align-items: center;
  gap: 8px;
}
.tab-icon-section .icon-option .icon-preview {
  width: 16px;
  height: 16px;
  object-fit: contain;
  border-radius: 2px;
}
.tab-icon-section .icon-option .icon-preview.custom-icon {
  width: 16px !important;
  height: 16px !important;
  font-size: 16px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.tab-icon-section .icon-option .icon-preview.custom-icon ::ng-deep svg {
  width: 16px;
  height: 16px;
}
.tab-icon-section .icon-preview-container {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background-color: #fafafa;
}
.tab-icon-section .icon-preview-container .icon-preview-large {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.tab-icon-section .icon-preview-container .icon-preview-large.custom-icon {
  width: 24px !important;
  height: 24px !important;
  font-size: 24px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.tab-icon-section .icon-preview-container .icon-preview-large.custom-icon ::ng-deep svg {
  width: 24px;
  height: 24px;
}
.tab-icon-section .icon-preview-container .icon-preview-text {
  font-weight: 500;
  color: #262626;
}
@media (min-width: 1400px) {
  .inspector-container form::-webkit-scrollbar {
    width: 12px;
  }
  .inspector-container form::-webkit-scrollbar-thumb {
    border: 3px solid #f5f5f5;
  }
}
.inline-toggle-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 12px;
  padding: 4px 0;
}
.inline-toggle-item {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 4px 0;
  font-size: 12px;
}
.inline-toggle-item label {
  margin-bottom: 0;
  line-height: 1.3;
}
.compact-alert ::ng-deep .ant-alert {
  padding: 6px 10px;
}
.compact-alert ::ng-deep .ant-alert .ant-alert-message {
  font-size: 12px;
}
.compact-alert ::ng-deep .ant-alert .ant-alert-description {
  font-size: 11px;
  line-height: 1.4;
}
.inline-switch-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 12px;
}
.inline-switch-group .inline-switch-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 4px 8px;
  background: #fafafa;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
  font-size: 12px;
}
.inline-switch-group .inline-switch-item .switch-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #595959;
  font-weight: 500;
}
.compact-info-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  margin-bottom: 8px;
  background: #f6ffed;
  border-radius: 4px;
  border: 1px solid #b7eb8f;
  font-size: 12px;
  color: #595959;
  font-weight: 500;
}
.compact-info-tip nz-icon {
  flex-shrink: 0;
  font-size: 14px;
}
.compact-info-tip span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::ng-deep .ant-form-item-label {
  padding-bottom: 2px !important;
}
::ng-deep .ant-form-item-label > label {
  font-size: 12px;
}
::ng-deep .ant-form-item-extra {
  font-size: 11px;
  min-height: auto;
  margin-top: 2px;
}
::ng-deep nz-divider.ant-divider {
  margin: 10px 0;
  font-size: 12px;
}
.dropdown-options-simple .config-options-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  font-weight: 500;
  font-size: 12px;
  margin-bottom: 8px;
}
.dropdown-options-simple .config-options-btn:hover {
  border-color: #40a9ff;
  color: #40a9ff;
}
.dropdown-options-simple .options-summary .options-count {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #f6ffed;
  border-radius: 4px;
  border: 1px solid #b7eb8f;
  margin-bottom: 8px;
}
.dropdown-options-simple .options-summary .options-count span {
  font-size: 12px;
  font-weight: 500;
  color: #389e0d;
}
.dropdown-options-simple .options-summary .options-preview-compact {
  padding: 8px 10px;
  background: #f0f7ff;
  border-radius: 4px;
  border: 1px solid #91d5ff;
}
.dropdown-options-simple .options-summary .options-preview-compact label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #0050b3;
}
.dropdown-options-simple .options-summary .options-preview-compact .tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.dropdown-options-simple .options-summary .options-preview-compact .tags-container nz-tag {
  margin: 0;
}
/*# sourceMappingURL=inspector.component.css.map */
